import { render, staticRenderFns } from "./radderChart.vue?vue&type=template&id=8b752fb6&"
import script from "./radderChart.vue?vue&type=script&lang=js&"
export * from "./radderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports